module.exports = __webpack_public_path__ + "static/gotm-b28e3b66ade62cee8cabea62172e1341.png";